<template>
  <div
    class="late-blight-cols__wrap"
    v-loading="loading"
    element-loading-text="加载中"
  >
    <div class="title" style="position:absolute;left: 20px;top: 18px;">
      <el-tag size="large">实时信息</el-tag>
    </div>

    <div class="mete-cols__container">
      <div v-if="!loading && !data.length" class="mete-cols__content no-data">
        <span>暂无数据</span>
      </div>

      <div
        v-else
        class="mete-cols__content"
        :style="{ transform }"
        :class="{ drag: moving }"
      >
        <div class="mete-cols__border" v-for="p in data" :key="p.id">
          <div class="mete-cols__img">
            <svg-icon :icon-class="p.icon" :color="p.color"></svg-icon>
            <div class="mete-cols__value">{{ formatter(p) }}</div>
            <span class="mete-cols__name">{{ p.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const MOVE_LENGTH = 500 // 每次点击移动的距离
// const DURATION = 1 // 动画持续时间 (s)

export default {
  props: {
    loading: Boolean,
    data: Array
  },
  data() {
    return {
      translateX: 0,
      offset: 0,
      moving: false,
      min: 0,
      loadLimit: 10
    }
  },
  computed: {
    transform() {
      return `translate(${this.translateX}px, 0)`
    }
  },
  mounted() {
    document.addEventListener('mouseup', this.onMouseup)
    const container = document.getElementsByClassName('mete-cols__container')[0]
    const el = document.getElementsByClassName('mete-cols__content')[0]
    this.min = container.offsetWidth - el.offsetWidth
  },
  methods: {
    moveStart(e) {
      if (e.button !== 0) return

      e.preventDefault()
      this.moving = true
      this.offset = this.translateX - e.clientX
    },
    move({ clientX: x }) {
      if (this.moving) {
        const offset = x + this.offset

        if (offset > 0) {
          this.translateX = 0
        } else if (offset < this.min) {
          this.translateX = this.min
        } else {
          this.translateX = offset
        }
      }
    },
    onClick(id) {
      this.$emit('change', id)
    },
    onMouseup() {
      this.moving = false
      this.offset = 0
    },
    moveLeft() {
      const offset = this.translateX + MOVE_LENGTH
      if (offset > 0) {
        this.translateX = 0
      } else {
        this.translateX = offset
      }
    },
    moveRight() {
      const offset = this.translateX - MOVE_LENGTH
      const limit = this.loadLimit + 7
      this.loadLimit = limit > this.data.length ? this.data.length : limit
      if (offset < this.min) {
        this.translateX = this.min
      } else {
        this.translateX = offset
      }
    },
    moveLeftEnd() {
      this.translateX = 0
    },
    moveRightEnd() {
      this.loadLimit = this.data.length
      this.translateX = this.min
    },
    formatter(item) {
      if (item.name === '风向') {
        return this.getWindDirection(item.value)
      }
      return `${item.value} ${item.unit}`
    },
    getWindDirection(degrees) {
      let direction

      if (degrees < 22.5 || degrees >= 337.5) {
        direction = '北'
      } else if (degrees < 67.5) {
        direction = '东北'
      } else if (degrees < 112.5) {
        direction = '东'
      } else if (degrees < 157.5) {
        direction = '东南'
      } else if (degrees < 202.5) {
        direction = '南'
      } else if (degrees < 247.5) {
        direction = '西南'
      } else if (degrees < 292.5) {
        direction = '西'
      } else if (degrees < 337.5) {
        direction = '西北'
      }

      return direction
    }
  },
  watch: {
    data() {
      this.$nextTick(() => {
        const container = document.getElementsByClassName(
          'mete-cols__container'
        )[0]
        const el = document.getElementsByClassName('mete-cols__content')[0]
        this.min = container.offsetWidth - el.offsetWidth
        this.translateX = 0
      })
    }
  }
}
</script>

<style lang="scss">
.late-blight-cols__wrap {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  // max-width: 1270px;
  background-color: #fff;
  z-index: 2;
  height: 150px;
  // border-bottom: 1px dashed #dcdfe6;
  .mete-cols__container {
    overflow: hidden;
  }
  .mete-cols__button {
    width: 5%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 2rem;
  }
  .mete-cols__content {
    float: left;
    left: 10%;
    height: 100%;
    white-space: nowrap;
    transition: transform 0.5s;
  }
  .mete-cols__border {
    position: relative;
    display: inline-block;
    // height: 150px;
    padding-top: 16px;
    padding-bottom: 16px;
    &:not(:last-child) {
      margin-right: 12px;
    }
  }
  .mete-cols__img {
    width: 118px;
    height: 118px;
    background: #fff;
    // border-radius: 50%;
    border: solid 2px rgba(0, 0, 0, 0.2);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    user-select: none;
    .svg-icon {
      width: 30px;
      height: 30px;
      margin-bottom: 4px;
    }
    .mete-cols__value {
      font-size: 15px;
      color: #606266;
      margin-bottom: 4px;
    }
    .mete-cols__name {
      font-size: 12px;
      color: #606266;
    }
  }
  .el-image.is-actived {
    border: 2px solid red;
  }
  .empty {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .drag {
    transition: none;
  }
}
</style>
